export default __webpack_public_path__ + "static/media/logo-mochi-simple-gray.7a803e98.svg";